import { useEffect, useState } from 'react'

import { SET_FOLDER_STATE } from 'redux/folders/actions/types'
import { useActionless, useAppSelector } from 'redux/hooks'
import { FoldersState } from 'redux/folders/initialState'

import ArchidektDropdown from 'components/elements/ArchidektDropdown'
import Icon from 'components/elements/Icon'

import styles from './folderColumnsControls.module.scss'

const FolderColumnControls = () => {
  const autoColumns = useAppSelector(state => state.folders.autoColumns)
  const columnData = useAppSelector(state => state.folders.columnData)

  const [setCollectionV2State] = useActionless(SET_FOLDER_STATE)

  const [changingState, setChangingState] = useState(false)

  const handleStateChange = (newState: Partial<FoldersState>) => {
    setChangingState(true)

    setTimeout(() => setCollectionV2State(newState), 20)
  }

  useEffect(() => {
    if (changingState) setChangingState(false)
  }, [autoColumns, columnData])

  useEffect(() => {
    if (!autoColumns) document.body.classList.add('deck-overscroll-view')
    else document.body.classList.remove('deck-overscroll-view')

    return () => {
      document.body.classList.remove('deck-overscroll-view')
    }
  }, [autoColumns])

  return (
    <div className={styles.container}>
      <ArchidektDropdown
        menuClassName={styles.menu}
        triggerClassName={styles.menu}
        options={[
          {
            type: 'checkbox',
            label: 'Automatic columns',
            onChange: () => handleStateChange({ autoColumns: !autoColumns }),
            checked: autoColumns,
          },
          { type: 'spacer' },
          {
            icon: 'check circle',
            label: 'Select all',
            disabled: autoColumns,
            onClick: () => handleStateChange({ columnData: columnData.map(c => ({ ...c, enabled: true })) }),
          },
          {
            icon: 'cancel',
            label: 'Deselect all',
            disabled: autoColumns,
            onClick: () => handleStateChange({ columnData: columnData.map(c => ({ ...c, enabled: false })) }),
          },
          { type: 'spacer' },
          ...(columnData.map(column => ({
            type: 'checkbox',
            label: column.label,
            disabled: autoColumns,
            checked: column.enabled,
            onChange: () =>
              handleStateChange({
                columnData: columnData.map(c => (c.key === column.key ? { ...c, enabled: !c.enabled } : c)),
              }),
          })) as any),
        ]}>
        <button className={styles.hideAddTrigger}>
          <Icon name="cog" />
          Hide / add columns
        </button>
      </ArchidektDropdown>
    </div>
  )
}

export default FolderColumnControls
